import * as tslib_1 from "tslib";
import { EnvBaseConfig } from './environment.config';
var env = {
    cvsProdHost: ['www.cvs.com', 'www-beta.cvs.com', 't.cvs.com', 'm.cvs.com', 'es.cvs.com']
};
/* tslint:disable */
function isProd() {
    var host = window.location.host;
    return env.cvsProdHost.indexOf(host) > -1;
}
// set the production environment to true
// export the new configuration
var EnvConfig = /** @class */ (function (_super) {
    tslib_1.__extends(EnvConfig, _super);
    function EnvConfig() {
        var _this = _super.call(this) || this;
        _this.production = true;
        return _this;
    }
    return EnvConfig;
}(EnvBaseConfig));
// export the new configuration
export var environment = tslib_1.__assign({}, new EnvConfig());
